import { ContainerOutlined, DeleteOutlined, DownloadOutlined, EditOutlined, SaveOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Card, Checkbox, Col, DatePicker, Form, Input, Modal, notification, Popconfirm, Row, Select, Skeleton, Space, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react'
import { useStoreActions, useStoreState } from '../../../store/hooks/easyPeasy';
import Table from "../../../contents/AntTableResponsive";
import { SelectLedgerCashEqui } from '../../select/SelectLedgerCashEqui';
import moment from 'moment';
import { SelectSemesterYear } from '../../select/SelectSemesterYear';
import { SelectAcademicYear } from '../../select/SelectAcademicYear';


export default function ColllectSingle(props) {

    const [form] = Form.useForm();
    const [updateForm] = Form.useForm();

    const singlePaySlip = useStoreState((state) => state.payslip.singlePaySlip);
    const fetchSinglePaySlip = useStoreActions((state) => state.payslip.fetchSinglePaySlip);
    const collectPayslip = useStoreActions((state) => state.payslip.collectPayslip);
    const deletePayslip = useStoreActions((state) => state.payslip.deletePayslip);
    const deletePayslipPaid = useStoreActions((state) => state.payslip.deletePayslipPaid);
    const downloadPayslip = useStoreActions((state) => state.payslip.downloadPayslip);
    const loading = useStoreState((state) =>  state.payslip.loading);



    // useEffect(() => {
    //     fetchfeeHeadList();
    // }, [])
    const [data, setData] = useState<any>();
    const formSubmit = (value) => {
        setData(value)
        fetchSinglePaySlip(value)
    }

    const updateFomrSubmit = (value) => {
        value.payslipIds = selectedValue.map(item => item.payslipId);
        value.paymentDate = moment(value?.paymentDate).format("YYYY-MM-DD");
        collectPayslip(value);
        setIsModalVisible(false);
        updateForm.resetFields()
        setselectedRowKeys([]);
        setselectedValue([]);
        setTimeout(() => {
            fetchSinglePaySlip(data)
        }, 1000);


    }


    const columns = [

        {
            title: 'Payslip ID',
            dataIndex: 'payslipId',
            key: 'payslipId',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Student ID',
            dataIndex: 'studentCustomId',
            key: 'studentCustomId',
            showOnResponse: true,
            showOnDesktop: true,
        },

        {
            title: 'Student Name',
            dataIndex: 'studentName',
            key: 'studentName',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Roll',
            dataIndex: 'Roll',
            key: 'Roll',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Create Date',
            dataIndex: 'createDate',
            key: 'createDate',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Total Amount',
            dataIndex: 'total',
            key: 'total',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Status',
            dataIndex: 'payslipStatus',
            key: 'payslipStatus',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Action',
            key: 'payslipId',
            showOnResponse: true,
            showOnDesktop: true,
            render: (text: any, record: any, index) => (
                <Space size="middle">

                    <Popconfirm
                        title="Are you sure to delete this?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => {
                            data?.payslipStatus === 1 ? deletePayslipPaid(record?.payslipId) : deletePayslip(record?.payslipId);
                            setTimeout(() => {
                                fetchSinglePaySlip(data)
                            }, 1000);
                        }}
                    >
                        <Tooltip title="Delete">
                            <Button danger icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm>

                    <Tooltip title="Download">
                        <Button type="primary" onClick={() => downloadPayslip(record?.payslipId)} icon={<DownloadOutlined />} />
                    </Tooltip>

                </Space>
            ),
        },

    ];

    const [isModalVisible, setIsModalVisible] = useState(false);

    const [dep, setDep] = useState<any>();
    const [year, setYear] = useState<any>();

    const [selectedRowKeys, setselectedRowKeys] = useState<any>([]);
    const [selectedValue, setselectedValue] = useState<any>([]);

    const onSelectChange = (selectedRowKeys, value) => {
        setselectedRowKeys(selectedRowKeys);
        setselectedValue(value);
        // console.log(value)
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const openModal = () => {
        if (selectedRowKeys.length > 0) {
            setIsModalVisible(true);
        } else {
            notification.error({
                message: 'Error',
                description: 'Please select at least one payslip',
            });
            return;
        }
    }

    return (
        <>

            <Form
                layout="vertical"
                onFinish={formSubmit}
                id="basic-info"
                form={form}
            >
                <Row gutter={8}>
                    <Col xs={24} sm={24} md={24} lg={3} xl={3}> </Col>

                    <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                        <Form.Item
                            name="customStudentId"
                            label="Student ID"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please input student id" },
                            ]}
                        >

                            <Input placeholder="Student ID" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                        <Form.Item
                            name="academicYear"
                            label="Academic Year"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please select year" },
                            ]}
                        >

                            <SelectAcademicYear selected={year} onChange={e => { setYear(e) }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                        <Form.Item
                            name="payslipStatus"
                            label="Status"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please select status" },
                            ]}
                        >

                            <Select placeholder="Select Status" allowClear>
                                <Select.Option value={0}>Unpaid</Select.Option>
                                <Select.Option value={1}>Paid</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={2} xl={2}>
                        <Space size="small" >
                            <Button type="primary" htmlType="submit" style={{ height: 40 }} icon={<SearchOutlined />}>
                                Search
                            </Button>
                        </Space>
                    </Col>

                </Row>
            </Form>
            < Skeleton loading={loading} paragraph={{rows:10}} />
            {singlePaySlip?.length > 0 &&
                <>
                    <div className="datatable-responsive">
                        {/* <Table bordered={true} ledgerList={ledgerList} columns={columns} className="p-datatable-responsive-demo" /> */}

                        <Table
                            antTableProps={{
                                showHeader: true,
                                columns,
                                dataSource: singlePaySlip,
                                filterData: singlePaySlip,
                                pagination: false,
                                bordered: true,
                                rowKey: "payslipId",
                                rowSelection: rowSelection,
                            }}
                            mobileBreakPoint={768}
                        />
                    </div>
                    <br />
                    {data?.payslipStatus === 0 && <Button type="primary" icon={<ContainerOutlined />} style={{ float: 'right' }} onClick={() => openModal()}> Collect</Button>}
                </>
            }


            <Modal
                title="Collect"
                visible={isModalVisible}
                //  onOk={handleOk}
                okButtonProps={{ form: 'update', htmlType: 'submit' }}
                onCancel={() => setIsModalVisible(false)}
                cancelText="Close"
                okText="Save"
                centered
            >
                <Form
                    layout="vertical"

                    onFinish={updateFomrSubmit}
                    id="update"
                    form={updateForm}
                >

                    <Form.Item
                        name="debitLedgerId"
                        label="Ledger:"
                        className="title-Text"
                        rules={[
                            { required: true, message: "Please select fee head" },
                        ]}
                    >
                        <SelectLedgerCashEqui style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item
                        name="paymentDate"
                        label="Payment Date"
                        className="title-Text"
                        initialValue={moment((new Date()).toISOString())}
                        rules={[
                            { required: true, message: "Please enter from date" },
                        ]}
                    >

                        <DatePicker style={{ width: '100%' }} placeholder="Select Date" format={"DD/MM/YYYY"} />
                    </Form.Item>
                </Form>

            </Modal>
        </>
    )
}
